import { Dropdown } from "antd";
import { LogOut, Phone } from "lucide-react";
import { useState } from "react";
import IMAGES from "../../assets/images";
import CustomImage from "../../components/CustomImage";
import useAuth from "../../hooks/useAuth";
import cn from "../../lib/cn";

const ProfileMenu = () => {
  const { logout, verifiedInfo } = useAuth();
  const [open, setOpen] = useState(false);

  const photo = verifiedInfo?.photo || IMAGES.avatar;

  const dropdownContent = (
    <div className="w-80 overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-[0_16px_48px_-16px_rgba(16,24,40,0.22)]">
      {/* Identity: soft brand band with overlapping avatar */}
      <div className="h-16 bg-gradient-to-r from-theme-primary/20 via-theme-primary/10 to-transparent" />
      <div className="-mt-8 px-5 pb-4">
        <CustomImage
          width={64}
          height={64}
          className="rounded-full bg-white object-cover ring-4 ring-white"
          src={photo}
        />
        <p className="mt-3 truncate text-base font-semibold text-gray-900">
          {verifiedInfo?.name}
        </p>
        {verifiedInfo?.email && (
          <p className="truncate text-sm text-gray-500">{verifiedInfo.email}</p>
        )}
        {verifiedInfo?.phone && (
          <span className="mt-3 inline-flex items-center gap-1.5 rounded-full bg-gray-50 px-2.5 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-200">
            <Phone className="h-3.5 w-3.5 text-gray-400" strokeWidth={1.75} />
            {verifiedInfo.phone}
          </span>
        )}
      </div>

      {/* Sign out */}
      <div className="border-t border-gray-100 p-2">
        <button
          onClick={() => {
            setOpen(false);
            logout();
          }}
          className="group flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-left text-sm font-medium text-gray-700 transition-colors hover:bg-red-50 hover:text-red-600"
        >
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-gray-50 text-gray-500 ring-1 ring-inset ring-gray-200 transition-colors group-hover:bg-red-100 group-hover:text-red-600 group-hover:ring-red-200">
            <LogOut className="h-4 w-4" strokeWidth={1.75} />
          </span>
          Log out
        </button>
      </div>
    </div>
  );

  return (
    <div className="relative">
      <Dropdown
        open={open}
        onOpenChange={setOpen}
        placement="bottomRight"
        // Clear the 64px navbar with a little breathing room below it.
        align={{ offset: [0, 24] }}
        rootClassName="profile-dropdown"
        // Render inside the sticky navbar (not <body>) so the menu stays put
        // with the navbar while the page scrolls.
        getPopupContainer={(trigger) => trigger.parentElement ?? document.body}
        popupRender={() => dropdownContent}
        trigger={["click"]}
      >
        <button
          aria-label="Open profile menu"
          className={cn(
            "flex size-10 items-center justify-center rounded-full ring-2 ring-offset-2 transition-shadow",
            open
              ? "ring-theme-primary"
              : "ring-transparent hover:ring-gray-200",
          )}
        >
          <CustomImage
            width={40}
            height={40}
            className="rounded-full object-cover"
            src={photo}
          />
        </button>
      </Dropdown>
    </div>
  );
};

export default ProfileMenu;
